import { useQuery } from '@tanstack/react-query';
import { COMPLIANCE_TIMEOUT_MS, runComplianceRequest } from 'src/api/complianceRequest';
import { HandshakePainterServiceApiV1 } from 'src/api/handshakeApi';
import { useAnalyticsContext } from 'src/common/metrics';
import { useDefaultApiParams } from './useDefaultApiParams';
/**
 * Custom hook to fetch top-highlights product compliance data based on a single ASIN.
 */
export const useProductComplianceTopHighlights = ({ asin, enabled = true }) => {
    const defaultApiParams = useDefaultApiParams().getDefaultParams();
    const rumClient = useAnalyticsContext();
    return useQuery({
        queryKey: ['getProductComplianceTopHighlights', asin],
        queryFn: ({ signal }) => runComplianceRequest({
            eventPrefix: 'COMPLIANCE_TOP_HIGHLIGHTS',
            asin,
            timeoutMs: COMPLIANCE_TIMEOUT_MS.TOP_HIGHLIGHTS,
            querySignal: signal,
            rumClient,
            request: (requestSignal) => HandshakePainterServiceApiV1.getProductComplianceTopHighlights({
                asin: asin,
                xUserLinked: defaultApiParams.xUserLinked,
                xJoinId: defaultApiParams.xJoinId,
                marketplaceId: defaultApiParams.marketplaceId,
            }, { signal: requestSignal }),
        }),
        enabled: enabled && !!asin,
    });
};
